// src/screens/student/myprogress/MyProgress.js
import React, { useState } from 'react';
import '../../../assets/css/student/myprogress/MyProgress.css';
import StudentLayout from '../../../layouts/student/studentlayout/StudentLayout';
import { Col, Row } from 'react-bootstrap';

const MyProgress = () => {
  const [selectedPeriod, setSelectedPeriod] = useState('week'); // week, month, year
  const [selectedSubject, setSelectedSubject] = useState('all');

  const subjects = [
    { id: 'all', name: 'All Subjects', color: '#3e77d1' },
    { id: 'web-dev', name: 'Web Development', color: '#10b981' },
    { id: 'dsa', name: 'Data Structures', color: '#8b5cf6' },
    { id: 'ml', name: 'Machine Learning', color: '#f59e0b' }
  ];

  const overallStats = [
    {
      id: 1,
      label: 'Study Hours',
      value: '42.5h',
      change: '+12%',
      changeType: 'increase',
      icon: '⏱️',
      color: 'blue'
    },
    {
      id: 2,
      label: 'Sessions Attended',
      value: '28',
      change: '+8%',
      changeType: 'increase',
      icon: '🎥',
      color: 'green'
    },
    {
      id: 3,
      label: 'Quizzes Completed',
      value: '15',
      change: '+5',
      changeType: 'increase',
      icon: '📝',
      color: 'purple'
    },
    {
      id: 4,
      label: 'Average Score',
      value: '87%',
      change: '+3%',
      changeType: 'increase',
      icon: '🎯',
      color: 'orange'
    }
  ];


  const subjectProgress = [
    {
      subject: 'Web Development',
      progress: 85,
      hours: 24.5,
      sessions: 12,
      quizzes: 8,
      color: '#10b981'
    },
    {
      subject: 'Data Structures',
      progress: 72,
      hours: 18.2,
      sessions: 10,
      quizzes: 5,
      color: '#8b5cf6'
    },
    {
      subject: 'Machine Learning',
      progress: 64,
      hours: 15.8,
      sessions: 6,
      quizzes: 2,
      color: '#f59e0b'
    }
  ];

  const achievements = [
    {
      id: 1,
      title: '7 Day Streak',
      description: 'Studied for 7 consecutive days',
      icon: '🔥',
      earned: true,
      date: 'Earned today'
    },
    {
      id: 2,
      title: 'Quiz Master',
      description: 'Completed 15 quizzes',
      icon: '🏆',
      earned: true,
      date: 'Earned 3 days ago'
    },
    {
      id: 3,
      title: 'Team Player',
      description: 'Attended 25 group sessions',
      icon: '👥',
      earned: true,
      date: 'Earned 1 week ago'
    },
    {
      id: 4,
      title: 'Study Marathon',
      description: 'Study for 10 hours in one day',
      icon: '⏰',
      earned: false,
      progress: 82
    }
  ];

  const studyStreak = {
    current: 7,
    longest: 12,
    thisWeek: 7,
    thisMonth: 24
  };

  return (
    <StudentLayout>
    <div className="my-progress">
      {/* Header */}
      <div className="page-header">
        <div className="page-title-section">
          <div className="page-title-icon">📈</div>
          <div>
            <h1 className="page-title">My Progress</h1>
            <p className="page-description">Track your learning journey and achievements</p>
          </div>
        </div>
      </div>

      {/* Overall Stats */}
      <div className="progress-stats">
        {overallStats.map(stat => (
          <div key={stat.id} className={`stat-card stat-${stat.color}`}>
            <div className="stat-icon">{stat.icon}</div>
            <div className="stat-content">
              <div className="stat-label">{stat.label}</div>
              <div className="stat-value">{stat.value}</div>
              <div className={`stat-change ${stat.changeType}`}>
                <span className="change-icon">
                  {stat.changeType === 'increase' ? '↗' : '↘'}
                </span>
                <span>{stat.change} from last {selectedPeriod}</span>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="progress-content">
        {/* Left Column */}
        <div className="progress-main">
          {/* Study Streak */}
          <div className="content-card">
            <div className="card-header">
              <h3 className="card-title">
                <span>🔥</span>
                Study Streak
              </h3>
            </div>
            <div className="streak-container">
              <div className="streak-main">
                <div className="streak-number">{studyStreak.current}</div>
                <div className="streak-label">Day Streak</div>
              </div>
              <div className="streak-stats">
                <div className="streak-stat">
                  <div className="streak-stat-label">Longest Streak</div>
                  <div className="streak-stat-value">{studyStreak.longest} days</div>
                </div>
                <div className="streak-stat">
                  <div className="streak-stat-label">This Week</div>
                  <div className="streak-stat-value">{studyStreak.thisWeek} days</div>
                </div>
                <div className="streak-stat">
                  <div className="streak-stat-label">This Month</div>
                  <div className="streak-stat-value">{studyStreak.thisMonth} days</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Row className='mt-5'>
        <Col lg={4}>
          <div className="content-card">
            <div className="card-header">
              <h3 className="card-title">
                <span>🏆</span>
                Achievements
              </h3>
            </div>
            <div className="achievements-list">
              {achievements.map(achievement => (
                <div 
                  key={achievement.id} 
                  className={`achievement-item ${achievement.earned ? 'earned' : 'locked'}`}
                >
                  <div className="achievement-icon">{achievement.icon}</div>
                  <div className="achievement-content">
                    <div className="achievement-title">{achievement.title}</div>
                    <div className="achievement-description">{achievement.description}</div>
                    {achievement.earned ? (
                      <div className="achievement-date">{achievement.date}</div>
                    ) : (
                      <div className="achievement-progress">
                        <div className="achievement-progress-bar">
                          <div 
                            className="achievement-progress-fill"
                            style={{ width: `${achievement.progress}%` }}
                          />
                        </div>
                        <div className="achievement-progress-text">{achievement.progress}%</div>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>

        </Col>
        <Col lg={4}>
           <div className="content-card">
            <div className="card-header">
              <h3 className="card-title">
                <span>🎯</span>
                Performance
              </h3>
            </div>
            <div className="performance-stats">
              <div className="performance-item">
                <div className="performance-label">Attendance Rate</div>
                <div className="performance-value">94%</div>
                <div className="performance-bar">
                  <div className="performance-fill" style={{ width: '94%' }} />
                </div>
              </div>
              <div className="performance-item">
                <div className="performance-label">Quiz Average</div>
                <div className="performance-value">87%</div>
                <div className="performance-bar">
                  <div className="performance-fill" style={{ width: '87%' }} />
                </div>
              </div>
              <div className="performance-item">
                <div className="performance-label">Participation</div>
                <div className="performance-value">91%</div>
                <div className="performance-bar">
                  <div className="performance-fill" style={{ width: '91%' }} />
                </div>
              </div>
            </div>
          </div>

        </Col>
        <Col lg={4}>
          <div className="content-card">
            <div className="card-header">
              <h3 className="card-title">
                <span>🎯</span>
                Weekly Goals
              </h3>
            </div>
            <div className="goals-list">
              <div className="goal-item completed">
                <div className="goal-checkbox">✓</div>
                <div className="goal-text">Study 40 hours</div>
                <div className="goal-progress">42.5/40h</div>
              </div>
              <div className="goal-item completed">
                <div className="goal-checkbox">✓</div>
                <div className="goal-text">Attend 25 sessions</div>
                <div className="goal-progress">28/25</div>
              </div>
              <div className="goal-item">
                <div className="goal-checkbox"></div>
                <div className="goal-text">Complete 20 quizzes</div>
                <div className="goal-progress">15/20</div>
              </div>
              <div className="goal-item">
                <div className="goal-checkbox"></div>
                <div className="goal-text">Master 50 flashcards</div>
                <div className="goal-progress">38/50</div>
              </div>
            </div>
          </div>
        </Col>
         
      </Row>
    </div>
    </StudentLayout>
  );
};

export default MyProgress;